import * as types from './action-types';

export const initialState = {
  selectedBank: 'INITIAL',
  clearingNumber: {
    value: '',
    isValid: false,
    suppressError: true,
    errorMessage: ''
  },
  accountNumber: {
    value: '',
    isValid: false,
    suppressError: true,
    errorMessage: ''
  },

  banks: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.RESET:
      return Object.assign({}, initialState);

    case types.SET_BANKS:
      return Object.assign({}, state, {
        banks: action.payload
      });

    case types.SET_SELECTED_BANK:
      return Object.assign({}, state, {
        selectedBank: action.payload
      });

    case types.SET_CLEARING_NUMBER:
      return Object.assign({}, state, {
        clearingNumber: {
          ...state.clearingNumber,
          value: action.payload
        }
      });

    case types.SET_CLEARING_NUMBER_IS_VALID:
      return Object.assign({}, state, {
        clearingNumber: {
          ...state.clearingNumber,
          isValid: action.payload
        }
      });

    case types.SET_CLEARING_NUMBER_SUPPRESS_ERROR:
      return Object.assign({}, state, {
        clearingNumber: {
          ...state.clearingNumber,
          suppressError: action.payload
        }
      });

    case types.SET_CLEARING_NUMBER_ERROR_MESSAGE:
      return Object.assign({}, state, {
        clearingNumber: {
          ...state.clearingNumber,
          errorMessage: action.payload
        }
      });

    case types.SET_ACCOUNT_NUMBER:
      return Object.assign({}, state, {
        accountNumber: {
          ...state.accountNumber,
          value: action.payload
        }
      });

    case types.SET_ACCOUNT_NUMBER_IS_VALID:
      return Object.assign({}, state, {
        accountNumber: {
          ...state.accountNumber,
          isValid: action.payload
        }
      });

    case types.SET_ACCOUNT_NUMBER_SUPPRESS_ERROR:
      return Object.assign({}, state, {
        accountNumber: {
          ...state.accountNumber,
          suppressError: action.payload
        }
      });

    case types.SET_ACCOUNT_NUMBER_ERROR_MESSAGE:
      return Object.assign({}, state, {
        accountNumber: {
          ...state.accountNumber,
          errorMessage: action.payload
        }
      });
  }

  return state;
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/bank-info/reducer.js
 **/